module.exports = __webpack_public_path__ + "static/media/faqBalance-es-zh-Hant.a89db902.vtt";